<template>
  <node-view-wrapper
    contenteditable="false"
    draggable="false"
    class="editable-shorttag-inline"
    :class="node.attrs.align"
  >
    <figure>
      <img
        :src="node.attrs.src"
        :alt="node.attrs.alt"
        :title="node.attrs.title"
        :class="node.attrs.align"
      >
      <figcaption class="text-center">
        {{ node.attrs.subtitle }}
      </figcaption>
      <image-comp-btn
        btn-type="update"
        :src-prop="node.attrs.src"
        :alt-prop="node.attrs.alt"
        :title-prop="node.attrs.title"
        :align-prop="node.attrs.align"
        :subtitle-prop="node.attrs.subtitle"
        @update-content="tiptapContentUpdate"
      />
    </figure>
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  nodeViewProps,
} from '@tiptap/vue-2';
import ImageCompBtn from './ImageCompBtn.vue';

export default {
  name: 'ImageCompShorttag',
  components: {
    NodeViewWrapper,
    ImageCompBtn,
  },
  props: {
    ...nodeViewProps,
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    }
  },
  methods: {
    tiptapContentUpdate(updateData) {
      this.updateAttributes(updateData.attrs);
    },
  },
};
</script>
